/**
 * @generated SignedSource<<13f5cd9cc058a30e5842be82f5d59fed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateProfileImageFragment$data = {
  readonly address: {
    readonly resolvedName: {
      readonly address: string;
      readonly " $fragmentSpreads": FragmentRefs<"ENSAvatarFragment" | "NounResolvedNameFragment">;
    };
  };
  readonly tokensRepresented: {
    readonly amount: {
      readonly " $fragmentSpreads": FragmentRefs<"TokenAmountAsCurrencyDisplayFragment">;
    };
  };
  readonly " $fragmentType": "DelegateProfileImageFragment";
};
export type DelegateProfileImageFragment$key = {
  readonly " $data"?: DelegateProfileImageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateProfileImageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegateProfileImageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResolvedName",
          "kind": "LinkedField",
          "name": "resolvedName",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NounResolvedNameFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ENSAvatarFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VotingPower",
      "kind": "LinkedField",
      "name": "tokensRepresented",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "amount",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TokenAmountAsCurrencyDisplayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "e8381c5c4a20fa3d3d5fb1a43793eb55";

export default node;
